export const NotAccessLanding = (): JSX.Element => {
    return <>{"You don't have permission to do this. Please get in touch with your administrator."}</>;
};
